import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { IAroTable } from "../common/inject";
import * as utils from "../common/utils";
import * as consts from "../common/consts";
import { aspMngr } from "../asp/AspMngr";
import { AroService } from "./aro.service";
import { TrackCoreObject } from "../asp/TrackCoreObject";

@Component({
  selector: "aro-table",
  templateUrl: "./aro-table.component.html",
  styleUrls: ["./aro.component.scss"]
})
export class AroTableComponent implements IAroTable, OnInit {
  public static readonly MAX_VALUES = 10;
  public static readonly MAX_OBJECTS = 10;

  private shown = false;
  private firstShow = true;
  private showNationality = false;

  private objectIds: Set<any>;

  public tableColumns: string[] = [];
  public tableValuesColumns: string[] = [];
  public tableValuesColumnsWidth: string[] = [];
  public tableData: Array<any> = [];
  public tableSelected: Array<boolean> = [];
  public tableDataSource = new MatTableDataSource(this.tableData);

  constructor(
    protected aroService: AroService,
    private cdRef: ChangeDetectorRef
  ) {
    let _this = this;
    setInterval(function () {
      _this.refresh();
    }, consts.DIALOG_REFRESH_INTERVAL);

    for (let i = 1; i <= AroTableComponent.MAX_VALUES; i++)
      this.tableValuesColumns.push(`value${i}`);
  }

  ngOnInit(): void {
    this.aroService.setAroTable(this);
  }

  show(objectIds: Set<any>): void {
    // set table structure upon first show
    if (this.firstShow) {
      let track = aspMngr.getObject(
        Array.from(objectIds)[0]
      ) as TrackCoreObject;

      this.tableColumns.push(`symbol`);

      for (let i = 1; i <= track.aroTableFieldsWidth().length; i++) {
        this.tableColumns.push(`value${i}`);
      }

      if (track.aroTableShowNationality()) {
        this.tableColumns.push(`nationality`);
        this.showNationality = true;
      }
      this.tableValuesColumnsWidth.push(...track.aroTableFieldsWidth());
      this.firstShow = false;
    }

    this.objectIds = objectIds;

    this.tableData = [];
    this.tableSelected = [];
    for (let id of this.objectIds.values()) {
      this.tableData.push({
        id: id,
        symbol: null,
        symbolColor: null,
        nationality: null,
        value1: null
      });
      this.tableSelected.push(false);
    }
    this.refresh(true);
    this.shown = true;
  }

  hide(): void {
    this.shown = false;
  }

  isShown(): boolean {
    return this.shown;
  }

  getObjectIds(): Set<any> {
    return this.objectIds;
  }

  private refresh(force?: boolean) {
    if (!force && !this.shown) return;

    let ids = Array.from(this.objectIds);

    for (let i = 0; i < ids.length; i++) {
      let obj = aspMngr.getObject(ids[i]);
      if (!obj || !obj.active) {
        // remove object from ARO list
        this.objectIds.delete(ids[i]);
        ids.splice(i, 1);
        this.tableData.splice(i, 1);
        this.tableSelected.splice(i, 1);
        i--;
      } else {
        let track = obj as TrackCoreObject;
        this.tableData[i].symbol = utils.getPlaneSymbol(track.symbol);
        this.tableData[i].symbolColor = utils.newmiColorToString(
          track.getColor()
        );

        let values = track.aroTableFields();
        for (let v = 0; v < values.length; v++)
          this.tableData[i][`value${v + 1}`] = values[v];

        if (this.showNationality)
          this.tableData[i].nationality = utils.getNationalityImage(
            track.modeSNationality
          );
      }
    }

    if (this.tableData.length == 0) {
      this.hide();
    } else {
      this.tableDataSource.data = this.tableData;
      this.cdRef.detectChanges();
    }
  }

  isAroDisabled() {
    return this.numSelectedRows() != 1;
  }

  isDropDisabled() {
    return true;
  }

  rowClicked(row: number) {
    this.tableSelected[row] = !this.tableSelected[row];
  }

  onAroBtnClick() {
    if (this.isAroDisabled()) return;
    let index = this.tableSelected.indexOf(true);
    let id = this.tableData[index].id;
    this.aroService.showTrackAro(id);
  }

  private numSelectedRows(): number {
    let num = this.tableSelected.filter(s => s).length;
    return num;
  }
}
